
import leftbanner from '../assets/images/left-banner.jpg';
import rightbanner from '../assets/images/right-banner.jpg';
import topbanner from '../assets/images/top-banner.jpg';
import bottombanner from '../assets/images/bottom-banner.jpg';


const initialHomeState = {
    bucket: {
        status : "initial",
        data : {
            ads : {
                desktop_left: {data:'<img src='+leftbanner+' alt="" />', popupname:""},
                desktop_right: {data:'<img src='+rightbanner+' alt="" />', popupname:""},
                mobile_top : {data:'<img src='+topbanner+' alt="" />', popupname:""},
                mobile_bottom: {data:'<img src='+bottombanner+' alt="" />', popupname:""}
            },
            video: '<iframe src="https://vimeo.com/event/2416643/embed" frameborder="0" id="livevideoiframe" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="width:100%;height:100%;"></iframe>',
            video_access: ""
        }
    },
    datatrack: 1
}
const HomeBucket = (state = initialHomeState , action) => {
    switch(action.type){
        case "SET_HOME_DATA":
            return {
                ...state,
                bucket: action.payload,
                datatrack: 0
            }
        case "SET_HOME_ADS_DATA":
            return {
                ...state,
                bucket: {
                    ...state.bucket,
                    data : { 
                        ...state.bucket.data,
                        ads : action.payload
                    }
                },
                datatrack: 0
            }
        case "SET_HOME_VIDEO_DATA":
        return {
            ...state,
            bucket: {
                ...state.bucket,
                data : { 
                    ...state.bucket.data,
                    video : action.payload
                }
            },
            datatrack: 0
        }
        default:
            return state
    }
}

export default HomeBucket;